import { render } from "./Reel.vue?vue&type=template&id=f8cf305a"
import script from "./Reel.vue?vue&type=script&lang=js"
export * from "./Reel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__